import { render, staticRenderFns } from "./RePrint.vue?vue&type=template&id=38a65150&scoped=true&"
import script from "./RePrint.vue?vue&type=script&lang=js&"
export * from "./RePrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a65150",
  null
  
)

export default component.exports